import { assign } from 'xstate';

export const setUsageKnown = assign(({ context, event }) => {
  return { ...context, ...event.values, isUsageKnown: true };
});
